import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  getAccessToken() {
    return sessionStorage.getItem('access_token');
  }
}
